import {
	VBtn,
	VIcon,
	VMenu
} from "vuetify/lib";

export default VMenu.extend( {
	name: "KDataTableMenu",

	props: {
		bottom: {
			default: true,
			type: Boolean
		},

		closeOnContentClick: {
			default: true,
			type: Boolean
		},

		left: {
			default: true,
			type: Boolean
		},

		offsetY: {
			default: true,
			type: Boolean
		}
	},

	methods: {
		genActivator() {
			const node = <VBtn
				attrs={this.genActivatorAttributes()}
				icon
				on={this.genActivatorListeners()}
				style="color: inherit;"
				value={this.getValueProxy()}
			>
				<VIcon>more_vert</VIcon>
			</VBtn>;

			this.activatorNode = node;

			return node;
		},

		getOpenDependents() {

			// We do this so children dialogs don't immediately close
			// if closeOnContentClick=true
			return [];
		}
	}
} );
